import React from 'react'
import { ProductModel } from '@wolf/entities'
import { getTranslations } from '../TranslationTemplate'

type Translations = ReturnType<typeof getTranslations>

type Props = {
  weight: number
  nutritionFacts: ProductModel['nutritionFacts']
  t: Translations
}

const kcalToKj = (kcal: number): string => (kcal * 4.184).toFixed(1).toString()

export const NutritionTable: React.FC<Props> = ({ weight, nutritionFacts, t }) => (
  <div className="nutricion">
    <table>
      <tbody>
        <tr>
          <th className="left">{t.nutritionFactsTitle}</th>
          <th className="right">{t.per100g}</th>
          <th className="right">{t.serving} {weight} g</th>
        </tr>
        {Object.keys(t.nutritionFacts).map((key) => {
          const value = nutritionFacts[key as keyof typeof nutritionFacts]
          if (value === undefined) return null
          const total = (value * weight) / 100
          return (
            <tr key={key}>
              <td className="left">{t.nutritionFacts[key]}</td>
              <td className="right">
                {key === 'energy' ? `${kcalToKj(value)} kJ / ${value} kcal` : `${value} g`}
              </td>
              <td className="right">
                {key === 'energy'
                  ? `${kcalToKj(total)} kJ / ${total.toFixed(2)} kcal`
                  : `${total.toFixed(2)} g`}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    <p className="net-weight">{t.netWeight}: {weight}g</p>
  </div>
)
